import { useState, useEffect, useCallback } from 'react';
import api from '../api/api';

const sortVideos = (arr = []) =>
    [...arr].sort((a, b) => {
        const aNum = parseInt(a?.filename?.match(/\d+/)?.[0] ?? '0', 10);
        const bNum = parseInt(b?.filename?.match(/\d+/)?.[0] ?? '0', 10);
        return bNum - aNum;
    });

export function useVideos({ auto = true } = {}) {
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] =     useState(auto);
    const [error, setError] = useState(null);

    const refresh = useCallback(async () => {
        setLoading(true);
        try {
            const res = await api.get('/videos');
            const list = Array.isArray(res.data) ? res.data : [];
            setVideos(sortVideos(list));
            setError(null);
        } catch (e) {
            console.error('Fehler beim Laden der Videos:', e);
            setError(e);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (auto) refresh();
    }, [auto, refresh]);

    return { videos, loading, error, refresh };
}

export function formatVideoOption(v) {
    return `${v.filename} - ${v.release_date} - ${v.game ?? ''}`;
}